<template>
  <Select
    v-bind="{ shouldSelect, ...$props }"
    :disabled="disabled"
    v-model="model"
    :ignore-form-editable="ignoreFormEditable"
    @update:model-value="updateModelValue"
  />
</template>
<script setup>
/*

This component same as Select but it's model is IdObject

*/

import Select from '@/components/select/select.vue'
import { getCurrentInstance } from 'vue'

const model = defineModel()
const emit = defineEmits(['update:model-value'])

defineProps({
  disabled: { type: Boolean, default: false },
  ignoreFormEditable: { type: Boolean, default: false }
})

const iam = getCurrentInstance()

const shouldSelect = v => (v || {})?.id

function updateModelValue(id) {
  let val
  const opt = iam.attrs.options.find(o => o.id == id)
  if (opt !== undefined) {
    val = { id: opt.id }
  }
  emit('update:model-value', val)
}
</script>
